export default __webpack_public_path__ + "static/assets/df1e4e6760d6cfff89a73da84972acdf.gif";